import React, { type FC } from 'react';

import { Stack } from '@/components/layout';
import { RadioGroup, Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { MutatePlayerForm } from '@/features/player/components/mutate-player/types';
import { createStyles, useScaling } from '@/hooks';
import { colors } from '@/theme/colors';
import { Controller, useFormContext } from 'react-hook-form';

type MutatePlayerClubSectionProps = {};

export const MutatePlayerClubSection: FC<MutatePlayerClubSectionProps> = () => {
  const { scale, isTablet } = useScaling();
  const styles = useStyles();
  const { control } = useFormContext<MutatePlayerForm>();

  return (
    <Stack gap={scale(12)} width="100%" marginTop={isTablet ? 0 : scale(16)}>
      <Text
        variant="Font Montserrat/Subtitle/Minimize 1 Bold 11px"
        fontWeight="800"
        style={styles.sectionTitle}>
        {STRINGS.player.mutatePlayer.club.title}
      </Text>
      <Stack direction={isTablet ? 'row' : 'column'} gap={scale(12)} width="100%">
        <Stack
          flex={isTablet ? 1 : undefined}
          gap={scale(6)}
          marginBottom={isTablet ? 0 : scale(16)}>
          <Text variant="Font Inter/Subtitle/Medium" style={styles.sectionLabel}>
            {STRINGS.player.mutatePlayer.club.needClubs}
          </Text>
          <Controller
            name="needClubs"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <>
                <RadioGroup
                  value={value}
                  onValueChange={needClubs => onChange(needClubs)}
                  direction="row"
                  itemGap={0}>
                  <RadioGroup.Radio
                    style={styles.radioItem}
                    color={colors.Blue}
                    value="yes"
                    label={STRINGS.player.mutatePlayer.club.yes}
                  />
                  <RadioGroup.Radio
                    style={styles.radioItem}
                    color={colors.Blue}
                    value="no"
                    label={STRINGS.player.mutatePlayer.club.no}
                  />
                </RadioGroup>
                {error?.message ? (
                  <Text variant="Font Inter/Subtitle/Regular 11px" style={styles.errorText}>
                    {error.message as string}
                  </Text>
                ) : null}
              </>
            )}
          />
        </Stack>

        <Stack flex={isTablet ? 1 : undefined} gap={scale(6)}>
          <Text variant="Font Inter/Subtitle/Medium" style={styles.sectionLabel}>
            {STRINGS.player.mutatePlayer.club.dominantHand}
          </Text>
          <Controller
            name="dominantHand"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <>
                <RadioGroup
                  value={value}
                  onValueChange={dominantHand => onChange(dominantHand)}
                  direction="row"
                  itemGap={0}>
                  <RadioGroup.Radio
                    style={styles.radioItem}
                    color={colors.Blue}
                    value="left"
                    label={STRINGS.player.mutatePlayer.club.left}
                  />
                  <RadioGroup.Radio
                    style={styles.radioItem}
                    color={colors.Blue}
                    value="right"
                    label={STRINGS.player.mutatePlayer.club.right}
                  />
                </RadioGroup>
                {error?.message ? (
                  <Text variant="Font Inter/Subtitle/Regular 11px" style={styles.errorText}>
                    {error.message as string}
                  </Text>
                ) : null}
              </>
            )}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

const useStyles = createStyles(() => ({
  sectionTitle: {
    color: colors.Blue,
    textTransform: 'uppercase',
  },
  sectionLabel: {
    color: colors['10'],
    textTransform: 'uppercase',
  },
  radioItem: {
    flexBasis: '50%',
    maxWidth: '50%',
  },
  radioItemTablet: {
    flexBasis: '50%',
    maxWidth: '50%',
  },
  errorText: {
    color: colors.Error,
  },
}));
